import { matchPath } from "react-router-dom";
import type { TInnerRoute } from "../types/innerLayout/nav-links";

export const isNavItemHidden = (currentPath: TInnerRoute, hiddenNavItemRoutes: TInnerRoute[]): boolean => {
  return hiddenNavItemRoutes.some((route) => matchPath({ path: route, end: true }, currentPath));
};